import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import Loading from "@client/controls/Loading/component";
import { Status, type WithIsEditMode } from "@client/types";
import { useUpdated } from "@common/lib/hooks";
import { isNull } from "lodash";
import * as React from "react";
import Content from "./Content/container";

import "./style.less";

export type MapProps = RootContainerProps &
  WithIsEditMode & {
    eventId: string | null | undefined;

    status: string;
  };
export interface ActionProps {
  onEventRequired: () => void;
  fetchPage: (page: number) => void;
}

export default (props: ActionProps & MapProps) => {
  React.useEffect(() => {
    if (isNull(props.eventId) && !props.isEditMode) {
      props.onEventRequired();
    }
  }, [props.eventId, props.isEditMode, props.onEventRequired]);

  useUpdated(() => {
    props.fetchPage(1);
  }, [props.eventId, props.fetchPage]);

  return (
    <Container className={"wsc_content_product_list"} {...getContainerProps(props)}>
      {props.status === Status.Loading ? <Loading isTransparent /> : <Content {...getRootContainerProps(props)} />}
    </Container>
  );
};
